import { wrap } from "../_"

const pfx = "/guest"

export default (a: NuxtAxiosInstance) => ({
  createGuestRecord: (email: string, cfg?: AxiosConfig) => wrap(
    a.$post(`${pfx}-record`, { email },
      { ...cfg })),
})
